module.exports = __webpack_public_path__ + "static/img/back-10-3.205105b5.png";